import { Placement } from "react-bootstrap/Overlay";
import { ReactNode, useState } from "react";

export type TooltipProps = {
  id: string;
  placement?: Placement;
  content: ReactNode;
  /**
   * Optional children to be wrapped by the tooltip component.
   * The component is commonly used as <ToolTipWrapped>...</ToolTipWrapped>
   */
  children?: ReactNode;
  enabled?: boolean;
  className?: string;
};

export default function useTooltipController({
  enabled = true,
  placement = "auto",
  ...rest
}: TooltipProps) {
  const [show, setShow] = useState(false);
  const tooltipEnabled = enabled;

  const onToggle = () => {
    setShow(!show);
  };

  const shouldRenderTooltip = () => tooltipEnabled && show;

  return {
    shouldRenderTooltip,
    onToggle,
    enabled,
    placement,
    ...rest,
  };
}
